'use client';

import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { isSupportedPlan } from 'types';
import { Container } from 'ui';

import { PlanCardList } from '~/plan/components/list';
import { UnauthNavigationLayout } from '~/ui';

import { SalesOnboardingWizard } from './SalesOnboardingWizard';

export const SalesOnboardingContainer = () => {
  const searchParams = useSearchParams();
  const [isPlanListVisible, setPlanListVisibility] = useState(false);

  const plan = searchParams && searchParams.get('plan');

  useEffect(() => {
    if (typeof plan !== 'string' || !isSupportedPlan(plan)) {
      setPlanListVisibility(true);
    }
  }, [plan]);

  if (isPlanListVisible) {
    return (
      <UnauthNavigationLayout>
        <PlanCardList baseUrl="/onboarding/sales" />
      </UnauthNavigationLayout>
    );
  }

  return (
    <Container sx={{ height: '100svh', padding: '0 !important' }} maxWidth={false}>
      {!isPlanListVisible && <SalesOnboardingWizard />}
    </Container>
  );
};
